import React, { FunctionComponent, useState } from "react";
import PageHelperModal from "./PageHelperModal";
import { useDispatch } from "react-redux";
import { openPageHelperModal } from "../../../store/help/actions";
import useUserRole from "../../../utils/hooks/useUserRole";
import { Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { useIntl } from "react-intl";

type OwnProps = {};

type Props = OwnProps;

const HelpButton: FunctionComponent<Props> = (props) => {
  // const dispatch = useDispatch();

  const { isCoach, isTeacher, isSupervisor, isDistrictOwner } = useUserRole();

  // const handleShowHelp = () => {
  //   dispatch(openPageHelperModal());
  // };
  const intl = useIntl();

  return isCoach || isTeacher || isSupervisor || isDistrictOwner ? (
    <Nav.Item as="div">
      <a
        href="https://readycoach.zendesk.com"
        target="_blank"
        rel="noopener noreferrer"
        className="nav-link"
      >
        <FontAwesomeIcon icon={faQuestionCircle} />
        &nbsp;Help
      </a>
    </Nav.Item>
  ) : null;
};

export default HelpButton;

